window.CSS = window.CSS || ({} as typeof CSS);

window.CSS.supports = (condition: string) => {
  return false;
};

//pollyfills
import "./polyfills/textEncoderPolyfill";
import "core-js/full";
import "mutationobserver-shim";

import "./assets/styles/global.scss";
import "./assets/styles/iran-yekan-x.font.scss";
import "./assets/styles/material.icon.scss";

// import eruda from "eruda";
// eruda.init();

import { StrictMode, Suspense } from "react";
import { render } from "react-dom";
import FullPageLoading from "./components/shared/loading/FullPageLoading";
import AuthContext from "./modules/auth/AuthContext";
import AuthWrapper from "./modules/auth/AuthWrapper";
import IspContextProvider from "./modules/isp/IspContextProvider";
import BootstrapRoutes from "./modules/router/BootstrapRoutes";
import { init } from "./modules/spatialNavigation";
import useMouseWheelNavigation from "./modules/spatialNavigation/useMouseWheelNavigation";
import ToastContextProvider from "./modules/toast/context/toastContextProvider";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

const Main = () => {
  useMouseWheelNavigation();

  return (
    <StrictMode>
      <Suspense fallback={<FullPageLoading loadingText="در حال بارگذاری" />}>
        <AuthContext>
          <ToastContextProvider>
            <AuthWrapper>
              <IspContextProvider>
                <BootstrapRoutes />
              </IspContextProvider>
            </AuthWrapper>
          </ToastContextProvider>
        </AuthContext>
      </Suspense>
    </StrictMode>
  );
};

const rootElement = document.getElementById("root");

if (!rootElement) console.error("No root element is found");
else render(<Main />, rootElement);

export default Main;
